/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S4_HeadingInputs */

const tr_kvkkbasvuru_s4_heading = /** @type {(inputs: Kvkkbasvuru_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Yanıt Süresi ve Ücret`)
};

const en_kvkkbasvuru_s4_heading = /** @type {(inputs: Kvkkbasvuru_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Response Period and Fee`)
};

const de_kvkkbasvuru_s4_heading = /** @type {(inputs: Kvkkbasvuru_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Antwortfrist und Gebühr`)
};

const ru_kvkkbasvuru_s4_heading = /** @type {(inputs: Kvkkbasvuru_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Срок ответа и плата`)
};

/**
* | output |
* | --- |
* | "4. Response Period and Fee" |
*
* @param {Kvkkbasvuru_S4_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s4_heading = /** @type {((inputs?: Kvkkbasvuru_S4_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S4_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s4_heading(inputs)
	if (locale === "de") return de_kvkkbasvuru_s4_heading(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s4_heading(inputs)
	return tr_kvkkbasvuru_s4_heading(inputs)
});